import { Link, useLocation } from 'react-router-dom';
import { NavBar } from '@/components/NavBar';
import { BarChart3, Shield, Users, ArrowLeftRight } from 'lucide-react';

const TABS = [
  { label: 'Concentration', href: '/concentration', icon: BarChart3 },
  { label: 'AUKUS Compliance', href: '/aukus', icon: Shield },
  { label: 'Modern Slavery', href: '/modern-slavery', icon: Users },
  { label: 'Sourcing', href: '/sourcing', icon: ArrowLeftRight },
];

export const AnalyticsShell = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <NavBar />
      {/* Analytics sub-tabs */}
      <div className="fixed top-14 left-0 right-0 z-40 bg-white border-b border-[#E0E0E0]" data-testid="analytics-tabs">
        <div className="px-4 lg:px-6 max-w-[1600px] mx-auto flex items-center gap-1 overflow-x-auto">
          {TABS.map(tab => {
            const active = pathname === tab.href;
            return (
              <Link key={tab.href} to={tab.href}
                className={`flex items-center gap-1.5 px-4 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${active ? 'border-[#0097A7] text-[#0D3B4F] font-medium' : 'border-transparent text-[#4E6974] hover:text-[#0D3B4F]'}`}
                data-testid={`analytics-tab-${tab.label.toLowerCase().replace(/\s+/g, '-')}`}>
                <tab.icon className="h-3.5 w-3.5" /> {tab.label}
              </Link>
            );
          })}
        </div>
      </div>
      <main className="pt-28 px-4 lg:px-6 pb-8">
        <div className="max-w-[1400px] mx-auto">{children}</div>
      </main>
    </div>
  );
};
